<template>
  <v-card>

    <v-toolbar dark class="identity-toolbar">
      <template v-slot:extension>
        <v-tabs v-model="tabs" centered>
          <v-tab>Already a member?</v-tab>
          <v-tab>New to Shopdrop?</v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <v-card flat>
          <Login class="sign-in-form" />
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <Register class="sign-in-form" />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import Register from "../components/Register";
import Login from "../components/Login";
import { mapGetters } from "vuex";

export default {
  name: "sign-in-card",
  components: {
    Register,
    Login,
  },
  data() {
    return {
      tabs: null,
    };
  },
  computed: {
    ...mapGetters(["isIframe"]),
  },
};
</script>

<style scoped>
.header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.sign-in-form {
  height: 40%;
  display: flex;
  background-color: white;
  padding: 2%;
}
</style>
